﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadScaleFeatureField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadScaleFeatureField, eOutputFieldType.cadScaleFeature)
export class CadScaleFeatureField extends OutputField implements ICadScaleFeatureField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public x: number;
    public y: number;
    public z: number;
    public isUniform: boolean;
    public scaleUniform: number;
}
